import { Modal, Button } from 'antd';
import React, { Component } from 'react';
import '../../ORDER/OrderMaster/style.css'
import Table from '../../Actions/Controls/Table/AntDTable'
import { Configuration, MandatoryFormFields, getDataTable, OnlyNumberKey } from '../../Configuration';
import AutoCompleteCascad from '../../Actions/Controls/AutoComplete/autoComplete.cascad';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'

export default class frmTierMaster extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            modal1Visible: false,
            modal2Visible: false,
            loginId: 0,
            orgid: 0,
            RSDATA: [],
            ORGID1:0,
            fldtierName:'',
            fldtierCode:''
        };
    }


    async componentDidMount() {
        let rs = await getDataTable("select orgid from users where userid = " + Configuration.USER_ID)
        await this.setState({
            loginId: Configuration.USER_ID,
            orgid: rs[0].orgid
        });
        await this.getdata(1)
    }

    setModal1Visible(modal1Visible) {
        this.setState({ modal1Visible });
    }

    setModal2Visible(modal2Visible) {
        this.setState({ modal2Visible });
    }

    myChangeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
        this.forceUpdate();
    }


    async getdata(val = 1) {
        let Que = "  SELECT  PortalTierMaster.tierName, PortalTierMaster.tierCode, FORMAT(PortalTierMaster.Logdate,'dd-MMM-yyyy') as Create_Date, OrganizationMaster.OrgName , tierID as [#tierID]"
        Que += " FROM  PortalTierMaster LEFT OUTER JOIN "
        Que += " OrganizationMaster ON PortalTierMaster.OrgID = OrganizationMaster.OrgID "
        let rs = await getDataTable(Que)
        if (rs.length > 0) {
            this.setState({ RSDATA: rs })
        }
        else {
            this.setState({ RSDATA: [] })
            return;
        }
    }



    async onAfterSelect(selectedOptions, id, name) {
        if (selectedOptions.length > 0) {
            this.setState({
                [id]: selectedOptions[0].DisplayId,
                [name]: selectedOptions[0].DisplayName,
            })
        }
        else {
            this.setState({
                [id]: '',
                [name]: '',
            })
        }
        this.forceUpdate();
    }



    async SaveTier() {
        let MandatoryArray = [
            { "TIER NAME": this.state.fldtierName },
            { "TIER CODE": this.state.fldtierCode }
        ]
        let check = MandatoryFormFields(MandatoryArray);
        if (check == false) {
            return false;
        }
        let que = "select * from PortalTierMaster where tierName = '" + this.state.fldtierName + "' and tierCode =  '" + this.state.fldtierCode +"' and OrgID = " + (this.state.ORGID1 ? this.state.ORGID1 : 0)
        let rs = await getDataTable(que)
        if (rs.length > 0) {
            Swal.fire({
                icon: 'error',
                title: "ALREADY EXIST",
                showConfirmButton: false,
                timer: 1500
            })

            return false;
        }
        que = "  "
        que += " INSERT INTO PortalTierMaster ( tierName, tierCode, OrgID, LoginID ) VALUES "
        que += "   ('" + this.state.fldtierName + "','" + this.state.fldtierCode + "'," + (this.state.ORGID1 ? this.state.ORGID1 : 0) + "," + this.state.loginId + ") "
        let rs1 = await getDataTable(que)
        Swal.fire({
            icon: 'success',
            title: "SUCCESSFULLY ADDED",
            showConfirmButton: false,
            timer: 1500
        })
        await this.getdata(this.state.orgid)
    }
    myChangeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    async deleteRow(e) {
        let st = await Swal.fire({ title: 'ARE YOU SURE WANT TO DELETE?', showCancelButton: true, confirmButtonText: 'YES', cancelButtonText: 'NO', })
        if (!st.isConfirmed) {
            return false;
        }
        let que = "Delete from PortalTierMaster where tierID = "+e['#tierID']
        let dt = await getDataTable(que)
        Swal.fire({
            icon: 'info',
            title: "SUCCESSFULLY REMOVED",
            showConfirmButton: false,
            timer: 1500
        })
        await this.getdata(this.state.orgid)
    }


    render() {

        return (
            <div>
                <button type="button" onClick={() => this.setModal2Visible(true)} className="btn btn-block btn-default">SET TIER</button>

                <Modal
                    title="TIER MASETR"
                    width={this.props.width}
                    visible={this.state.modal2Visible}
                    onOk={() => this.setModal2Visible(false)}
                    onCancel={() => this.setModal2Visible(false)}
                    destroyOnClose={true}
                    maskClosable={false}
                    footer={null}
                >
                    <div className='row'>
                        <div className="col-xs-6 col-sm-6 col-md-3 margintop">
                            <label>ENTER TIER NAME</label><span className="vcode">*</span>
                            <div className="form-group">
                                <input name="fldtierName" id="fldtierName" onChange={this.myChangeHandler} placeholder="ENTER TIER NAME" autoComplete="off" className="form-control" />
                            </div>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-3 margintop">
                            <label>ENTER TIER CODE</label><span className="vcode">*</span>
                            <div className="form-group">
                                <input name="fldtierCode" id="fldtierCode" onChange={this.myChangeHandler} placeholder="ENTER TIER CODE" autoComplete="off" className="form-control" />
                            </div>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-3 marginto">
                            <label>SELECT ORGANIZATION</label>
                            <AutoCompleteCascad
                                id="articleid"
                                frmNm="HEADER"
                                quryNm="FILLORGNIZATION"
                                db="IMAGEDB"
                                filter2=""
                                filterId2=''
                                filter1="UserID"
                                filterId1={Configuration.USER_ID}
                                placeholder="Please Select Organization"
                                onAfterSelect={(e) => this.onAfterSelect(e, "ORGID1", "ORGNAME1")}
                                isValid={this.state.isValid}
                            ></AutoCompleteCascad>
                        </div>
                        <div className='col-md-2 col-xs-6 col-sm-2 margintop'  >
                            <label>&nbsp;</label>
                            <div className='form-group'>
                                <button className='btn btn-block btn-primary' value='template' onClick={this.SaveTier.bind(this)}>Save</button>
                            </div>
                        </div>

                        <div className='col-md-12 col-xs-12 col-sm-12 margintop'>
                            {this.state.RSDATA.length > 0 && this.state.RSDATA != undefined &&
                                <Table
                                    data={this.state.RSDATA}
                                    Delete="true"
                                    DeleteFn={(e) => this.deleteRow(e)}
                                    height='63vh'
                                    id='fielddata'>
                                </Table>}
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }







}